import { render, staticRenderFns } from "./Canales.vue?vue&type=template&id=ca664dc4&"
import script from "./Canales.vue?vue&type=script&lang=js&"
export * from "./Canales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports